<main class="main-container">
  @if ((authService.isLoggedIn|async) && this.router.url !== '/login') {
    <div class="logout-container accent-font-3">
      <button mat-button class="logout" (click)="authService.logout()">
        <mat-icon svgIcon="pq:logout-arrow"></mat-icon>
        <span>{{'Logout'|translate}}</span>
      </button>
    </div>
  }
  <div class="header-container">
    <div class="logo-container">
      <!--            <img src="assets/images/logo-big.png" />-->
      <img [src]="(customization.config|async)?.logoUrl || 'assets/images/logo-big.png'" />
    </div>
    @if ((customization.config|async)?.welcome_message; as message) {
      <div
        class="message"
        [innerHtml]="message"
      ></div>
    }
    @if ((customization.config|async)?.global_welcome_message; as message) {
      <div
        class="message"
        [innerHtml]="message"
      ></div>
    }
  </div>
  <div class="router-container">
    <router-outlet></router-outlet>
  </div>
</main>
@if ((layout | async)?.footer) {
  <app-footer></app-footer>
}
